export const LogoMark = ({ size = 34 }) => (
    <svg width={size} height={size} viewBox="0 0 64 64" data-testid="logo-mark" aria-hidden="true">
        <rect x="2" y="2" width="60" height="60" rx="14" fill="#1D4ED8" />
        <text x="32" y="42" textAnchor="middle" fontFamily="'Syne',sans-serif" fontWeight="800" fontSize="29" fill="#FBF7EE">24</text>
        <rect x="14" y="48" width="36" height="5" rx="2.5" fill="#FACC15" />
    </svg>
);

export const Logo = () => (
    <a href="#top" data-testid="nav-logo" className="flex items-center gap-2.5" onClick={(e) => { e.preventDefault(); window.__lenis ? window.__lenis.scrollTo(0, { duration: 1.4 }) : window.scrollTo({ top: 0, behavior: "smooth" }); }}>
        <LogoMark />
        <span className="font-display text-xl font-extrabold tracking-tight text-ink">
            24<span className="text-inkblue">queue</span>
        </span>
    </a>
);
